import React from 'react'

export const vermontSetupVars = {
  siteId: 'vermont',
  pathPrefix: '/vt',
  menuHeader: "Discover Vermont's Solution for:",
  appUrl: 'https://vt.headed2.com',
  logoImg: '/images/assets/vermont/horizontal/dark.svg',
  headerTitle: `The Vermont CareerExplorer is a system designed for Vermont`
}
